











import { IRental } from "@/models/rental.entity";
import { Component, Prop, Vue } from "vue-property-decorator";
import RentalSheet from "./RentalSheet.vue";

@Component({
  components: {
    RentalSheet
  }
})
export default class RentalResponseCard extends Vue {
  @Prop({ required: true })
  value!: IRental;
}
